import styled from '@bd/bdui-styles/emotion';
import { typography } from '../styles';
import ClientLogin from '../bdcoreCandidates/ClientLogin';

export default styled(ClientLogin)`
  .form-heading {
    font-family: ${typography.SerifHead};
    font-weight:700;
    font-style: italic;
  }

  .ClientLogin_logout {
    width:100%;
    padding-bottom:20px;
  }

  .ClientLogin {
    display: flex;
    flex-flow:column wrap;
    justify-content: center;
  }
  .ClientLogin_bodyCopy {
    border-right: 1px solid black;
    max-width: 600px;
    padding: 50px;
  }
  .ClientLogin_formSection {
    width:100%;
    padding:0 40px 40px 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ClientLogin.js